import { createPopper } from '@popperjs/core';

const PefcScrollUp = (el: Element) => {
    const button = el.querySelectorAll('[role="button"]')[0];
    const tooltip = el.querySelectorAll('[role="tooltip"]')[0];
    const popperInstance = createPopper(button, tooltip as HTMLElement, {
        placement: 'bottom'
    });
    const modifiers = [
        { name: 'eventListeners', enabled: true },
    ];
    const showEvents = ['mouseenter', 'focus'];
    const hideEvents = ['mouseleave', 'blur'];
    const show = () => {
        tooltip.classList.add('headline__tooltip--open');
        // Enable the event listeners
        popperInstance.setOptions((options) => ({
            ...options,
            modifiers
        }));

        popperInstance.update();
    };
    const hide = () => {
        tooltip.classList.remove('headline__tooltip--open');
    };
    showEvents.forEach((event) => {
        button.addEventListener(event, show);
    });

    hideEvents.forEach((event) => {
        button.addEventListener(event, hide);
    });

    const scrollTop = () => window.scroll({ top: 0, behavior: 'smooth' });
    button.addEventListener('click', scrollTop);
};

export default PefcScrollUp;
